import { useQuery } from '@tanstack/react-query';
import { useApiClient } from './useApiClient';

const CONFIG_BASE = '/config';

export interface FeatureFlags {
  discover: boolean;
  matches: boolean;
  chat: boolean;
  profile: boolean;
  share: boolean;
  ipLocation?: boolean;
}

export interface UiConfigResponse {
  timestamp: string;
  features: FeatureFlags;
  auth0: {
    domain?: string;
    clientId?: string;
    audience?: string;
    scope?: string;
  };
  api: {
    endpoints: {
      profiles: string;
      discover: string;
      health: string;
      search: string;
      ipLocation?: string;
    };
  };
  logging: {
    enabled: boolean;
    level: 'debug' | 'info' | 'warn' | 'error';
  };
  search: {
    radius: number;
    unit: string;
  };
  user: {
    movedSignificantly: {
      distance: number;
      unit: string;
    };
  };
  discover?: {
    maxInterestFilters?: number;
  };
  location: {
    timeout: number;
    maxAge: number;
    highAccuracy: boolean;
    updateInterval: number;
    distanceThreshold: number;
    unit: string;
    freshnessThreshold?: number;
  };
  preferredDistanceUnit?: 'ft' | 'm';
}

export const useUiConfig = () => {
  const client = useApiClient();

  return useQuery({
    queryKey: ['config', 'ui'],
    queryFn: () => client.get<UiConfigResponse>(CONFIG_BASE),
  });
};
